import {
  ShippingModal,
  useShippingFees,
  buildPreCheckoutPositions,
} from '../../modules/shipping';
import type { ApiClient } from '../../modules/api';

export interface ShipDisclaimerModalProps {
  client: ApiClient;
  /** Selected Cards-tab items the disclaimer is shown for — sent to the fees
   *  endpoint so the handling row totals across the whole selection. */
  poolItemIds: (number | string)[];
  /** Sell the whole selection back instead of shipping. */
  onAcceptBuyback: () => void;
  /** Proceed to the delivery address form. */
  onAddDelivery: () => void;
  /** Close without committing — X button or backdrop click. */
  onClose: () => void;
}

/**
 * MyPacks ship Disclaimer — the transparency prompt shown before a user
 * commits the selected Cards to shipping vs. buyback.
 *
 * Reuses the shared `ShippingModal` with the same pre-checkout positions as
 * the reveal Create Shipping modal: shipping fee + sales tax can't be quoted
 * without an address ("TBD at Checkout"), and the flat handling fee comes
 * from the backend (`useShippingFees`). The disclaimer copy / actions are
 * MyPacks-specific; only the positions are backend-driven.
 */
export function ShipDisclaimerModal({
  client,
  poolItemIds,
  onAcceptBuyback,
  onAddDelivery,
  onClose,
}: ShipDisclaimerModalProps) {
  const { fees } = useShippingFees(client, poolItemIds);
  const positions = buildPreCheckoutPositions(fees?.handlingFee ?? null);

  return (
    <ShippingModal
      onClose={onClose}
      title="Disclaimer"
      description="We want to be fully transparent with our users and make it clear that if you choose shipping, you will need to pay:"
      positions={positions}
      note="Using buyback, you avoid these additional costs."
      secondary={{ label: 'Accept Buyback', onClick: onAcceptBuyback }}
      primary={{ label: 'Add Delivery', onClick: onAddDelivery }}
    />
  );
}
